import { useCallback } from "react";
import { ReactFlowInstance, UpdateNodeInternals } from "reactflow";
import { IBannerContext, BannerStatus } from "@plex/react-components";
import { decodeDocument } from "./DocumentEncode";
import { verifyAndLoadDocument } from "./DocumentProcessor";
import { IFlowDocumentModel } from "./FlowDocumentModel";

export interface UseFlowImportProps {
  flowInputController: any;
  reactFlowInstance: ReactFlowInstance;
  updateNodeInternals: UpdateNodeInternals;
  showCanvas: () => void;
  hideCanvas: () => void;
  getBannerContext: () => IBannerContext;
  setDocumentLoadingState: (state: { isLoading: boolean }) => void;
  documentLoadingState: { isLoading: boolean };
}

export const useFlowImport = ({
  flowInputController,
  reactFlowInstance,
  updateNodeInternals,
  showCanvas,
  hideCanvas,
  getBannerContext,
  setDocumentLoadingState,
  documentLoadingState
}: UseFlowImportProps) => {
  const handleFileSelect = useCallback(
    (content: string | undefined) => {
      if (content !== undefined) {
        setDocumentLoadingState({ isLoading: true });
        documentLoadingState.isLoading = true;

        decodeDocument(content)
          .then((decodedDocument: IFlowDocumentModel) => {
            verifyAndLoadDocument(
              decodedDocument,
              flowInputController,
              reactFlowInstance,
              updateNodeInternals,
              showCanvas,
              hideCanvas,
              getBannerContext(),
              () => {
                setDocumentLoadingState({ isLoading: false });
                documentLoadingState.isLoading = false;
              }
            );
          })
          .catch((reason: any) => {
            setDocumentLoadingState({ isLoading: false });
            documentLoadingState.isLoading = false;
            getBannerContext().addMessage("Flow cannot be loaded.", BannerStatus.error);
          });
      } else {
        console.log("No content returned from file input");
      }
    },
    [
      flowInputController,
      reactFlowInstance,
      updateNodeInternals,
      showCanvas,
      hideCanvas,
      getBannerContext,
      setDocumentLoadingState,
      documentLoadingState
    ]
  );

  return { handleFileSelect };
};
